/**
 * 常规列表的api 之后可以不使用service的方式 直接调取接口比较简单
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
    async getFormDetail(keyId) {
        return request(api.client.MAINTAINCUST + '/detail/' + keyId, METHOD.GET);
    },
    async saveFormDetail(result) {
        return request(api.client.MAINTAINCUST, METHOD.POST, result);
    },
    async doFile(params) {
        return request(api.client.MAINTAINCUST + '/doFile/', METHOD.PUT,params);
    },
    async selection(params) {
        return request(api.client.SELECTION, METHOD.GET, params)
    },
    async selectionStrain() { //品系下拉
        return request(api.clue.CLUE + '/getStrainList', METHOD.GET)
    }
}

export default {dataApi}
